import DOMPurify from "dompurify";

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html);
}

const OBSOLETE_REPORT_IDENTITY = /Suncoast Internal Medicine Consultants/i;

/**
 * Report footers are configured HTML, so keep only the small formatting subset
 * needed by TC/PC/IHC statements. Converting paragraphs to divs also removes
 * browser-default paragraph margins that produced blank-looking lines in PDFs.
 */
export function sanitizeReportFooterHtml(html: string): string {
  if (!html || OBSOLETE_REPORT_IDENTITY.test(html)) return "";

  let normalized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["div", "p", "br", "strong", "b", "em", "i", "u", "span"],
    ALLOWED_ATTR: ["class"],
  });

  // Remove blank blocks recursively so an empty child cannot leave an empty
  // parent behind. Covers persisted legacy forms such as &nbsp;, NBSP, and BR.
  let previous: string;
  do {
    previous = normalized;
    normalized = normalized.replace(
      /<(p|div)\b[^>]*>(?:\s|&nbsp;|\u00a0|<br\s*\/?\s*>)*<\/\1>/gi,
      ""
    );
  } while (normalized !== previous);

  return normalized
    .replace(/<p\b[^>]*>/gi, "<div>")
    .replace(/<\/p>/gi, "</div>")
    .replace(/<div([^>]*)>\s+<div/g, "<div$1><div")
    .replace(/<\/div>\s+<div/g, "</div><div")
    .replace(/<\/div>\s+<\/div>/g, "</div></div>")
    .trim();
}
